// Softline backend endpoints (ApiDataAccess) — unlike ai-table-extractor.api.ts,
// which addresses the belegleser extraction service.

// DTI profile of a supplier on the supplier-service; {{supplierId}} is the
// account id of the masterdata supplier (same id as the Lieferantenstamm uses).
export const SOFTLINE_API_SUPPLIER_DTI_DEFAULT_PRODUCT =
  'supplier-service/supplier/{{supplierId}}/dti-profile/default-product';
export const SOFTLINE_API_SUPPLIER_DTI_UNIT_MAPPINGS =
  'supplier-service/supplier/{{supplierId}}/dti-profile/unit-mappings';
